import {
  Avatar as MuiAvatar,
  AvatarGroup as MuiAvatarGroup,
  type AvatarGroupProps as MuiAvatarGroupProps,
  type AvatarProps as MuiAvatarProps
} from "@mui/material";

export type AvatarProps = MuiAvatarProps;
export type AvatarGroupProps = MuiAvatarGroupProps;

export const Avatar = MuiAvatar;
export const AvatarGroup = MuiAvatarGroup;
